"use client";

import React from "react";
import { Mail, Linkedin, Twitter, Instagram, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AboutBio() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <section data-section-id="28934" id="mi-rol-durante-el-proceso" ref={ref} className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 items-center">
          {/* Portrait Column */}
          <div className={cn("relative w-full max-w-md mx-auto lg:mx-0 aspect-[3/4] rounded-[8px] overflow-hidden shadow-medium transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="absolute inset-0 bg-primary/5 z-10" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/portrait_bio_image.png" alt="Retrato de Guillermo" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
          </div>

          {/* Bio Column */}
          <div className={cn("flex flex-col space-y-8 transition-all duration-1000 ease-out delay-200", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="space-y-4">
              <h2 className="text-3xl font-display font-bold tracking-tight sm:text-4xl md:text-5xl text-foreground">
                Mi Rol en tu Proceso
              </h2>
              <p className="text-xl font-sans font-medium text-primary">
                Guillermo | Coach de Transformación & Guía
              </p>
            </div>

            <div className="space-y-4 text-foreground/80 text-lg leading-[1.6] [&>p]:before:content-['✓'] [&>p]:before:text-accent [&>p]:before:mr-3 [&>p]:before:font-bold">
              <p>
                Facilitador de Espacios: Mi compromiso es crear un entorno de seguridad y confianza absoluta donde puedas explorar tus desafíos actuales sin juicios, permitiendo que emerjan tus verdaderas inquietudes.
              </p>
              <p>
                Espejo de Consciencia: Actúo como un reflejo de tus patrones de pensamiento y lenguaje, ayudándote a identificar aquellas creencias limitantes que hoy frenan tu capacidad de acción y bienestar personal.
              </p>
              <p>
                Socio en el Diseño: Colaboro contigo en la creación de estrategias personalizadas y hábitos sostenibles que te permitan transformar tu realidad y alcanzar los resultados extraordinarios que buscas.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 pt-4 items-start sm:items-center">
              <Button asChild size="lg" className="rounded-[4px] px-8 bg-primary hover:bg-primary-hover text-foreground-primary">
                <Link to="/ContactReserveSessionPage">
                  <Mail className="mr-2 h-4 w-4" /> Reserva tu Sesión
                </Link>
              </Button>

              <div className="flex items-center gap-4">
                {socialLinks.map((social, i) => <Link key={i} to={social.href} newTab className="text-muted-foreground hover:text-accent transition-colors p-2 rounded-full hover:bg-muted-light-background" aria-label={social.label} data-index={i}>
                    <social.icon className="h-6 w-6" />
                  </Link>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}